/* eslint-disable */

import Vue from 'vue'
import VueRouter from 'vue-router'

import Start from './views/Start'
import TermsOfUse from './views/TermsOfUse'
import Result from './views/Result'
import Bulk from './views/Bulk'
import Results from './views/Results'
import Token from './views/Token'
import Companies from './views/Companies.vue'
import { authenticate } from '../auth'
import { loadTermsOfUseAcceptanceFromBackend, termsOfUseAccepted } from '../agb'

Vue.use(VueRouter)

function toArray(param) {
  if (param) {
    return Array.isArray(param) ? param : [param]
  }
  return []
}

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Start',
      component: Start
    },
    {
      path: '/agb',
      name: 'TermsOfUse',
      component: TermsOfUse
    },
    {
      path: '/result/:search(\\d{1,14})',
      name: 'Result',
      component: Result,
      props: route => ({
        back: route.query.bulk !== undefined,
        search: route.params.search
      })
    },
    {
      path: '/companies',
      name: 'Companies',
      component: Companies,
      beforeEnter: (to, from, next) => {
        if (to.query.q) {
          next()
        } else {
          next({ name: 'Start' })
        }
      },
      props: route => ({
        query: JSON.parse(decodeURI(route.query.q))
      })
    },
    {
      path: '/bulk',
      name: 'Bulk',
      component: Bulk
    },
    {
      path: '/bulk/results',
      name: 'Results',
      component: Results,
      props: route => ({
        gtins: toArray(route.query.g)
      })
    },
    {
      path: '/token',
      name: 'Token',
      component: Token
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const code = Object.assign({}, to.query, from.query).code
  authenticate(code).then(success => {
    if (!termsOfUseAccepted() && success) {
      loadTermsOfUseAcceptanceFromBackend().then(() => {
        if (termsOfUseAccepted() || to.name === 'TermsOfUse') next()
        else
          next({
            name: 'TermsOfUse',
            query: Object.assign({}, to.query, from.query)
          })
      })
    } else next()
  })
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js